import { getLoginUrl } from '../utils/auth';
import { pageVar } from '../state/appState';
import { useReactiveVar } from '@apollo/client';

export function useLoginPageUrl() {
  const page = useReactiveVar(pageVar);

  return getLoginUrl({
    campaignId: page?.cause?.campaignId,
    campaignTitle: page?.cause?.campaignTitle,
    causeLogo: page?.cause?.logo,
    charityName: page?.cause?.name,
    eventName: page?.event?.name,
    title: 'Log in to personalise your page',
  });
}
